// Productreviews: formulier in een dialoogvenster. Foto's en video's worden pas bij het versturen geüpload (met voortgang);
// reviews gaan naar het beoordelingssysteem van Ivonne en staan pas online nadat zij ze heeft goedgekeurd.
(() => {
  'use strict';
  const root = document.querySelector('[data-product-reviews]');
  if (!root) return;
  const dialog = root.querySelector('[data-review-dialog]'), form = root.querySelector('[data-review-form]');
  const openers = root.querySelectorAll('[data-review-open]');
  if (!dialog || !form || typeof dialog.showModal !== 'function') { openers.forEach((b) => { b.hidden = true; }); return; }

  const strings = JSON.parse(root.querySelector('[data-review-strings]').textContent);
  const api = (root.dataset.api || '').replace(/\/+$/, '');
  const LIMITS = { images: 3, imageBytes: 8 * 1024 * 1024, videos: 1, videoBytes: 80 * 1024 * 1024 };
  const KIND = { 'image/jpeg': 'image', 'image/png': 'image', 'image/webp': 'image', 'video/mp4': 'video', 'video/quicktime': 'video', 'video/webm': 'video' };
  const fmt = (text, values) => text.replace(/%([a-z])/g, (m, k) => (k in values ? values[k] : m));
  const $ = (selector) => form.querySelector(selector);
  const fieldError = (name) => form.querySelector(`[data-error-for="${name}"]`);
  const statusLine = $('[data-review-status]'), formError = $('[data-review-error]'), submit = $('[data-review-submit]'), list = $('[data-review-files]'), picker = $('#pr-media');

  let files = []; // { file, kind, url, bar }
  let busy = false;

  function clearErrors() {
    formError.textContent = ''; statusLine.textContent = '';
    form.querySelectorAll('[data-error-for]').forEach((p) => { p.textContent = ''; });
    form.querySelectorAll('[aria-invalid]').forEach((el) => el.removeAttribute('aria-invalid'));
  }
  function showFieldError(name, message) {
    const p = fieldError(name); if (p) p.textContent = message;
    const input = name === 'rating' ? null : form.elements[name]; if (input) input.setAttribute('aria-invalid', 'true');
  }

  function open() {
    clearErrors();
    root.querySelector('[data-review-success]').hidden = true; form.querySelector('[data-review-fields]').hidden = false;
    if (!form.elements.name.value && root.dataset.name) form.elements.name.value = root.dataset.name;
    if (!form.elements.email.value && root.dataset.email) form.elements.email.value = root.dataset.email;
    dialog.showModal();
  }
  const close = () => dialog.close();

  function renderFiles() {
    list.innerHTML = '';
    files.forEach((entry, index) => {
      const li = document.createElement('li');
      if (entry.kind === 'image') { const img = document.createElement('img'); img.src = entry.url; img.alt = entry.file.name; li.append(img); }
      else { const box = document.createElement('span'); box.className = 'pr-filevideo'; box.setAttribute('role', 'img'); box.setAttribute('aria-label', entry.file.name); box.textContent = '▶'; li.append(box); }
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label', fmt(strings.remove, { n: entry.file.name }));
      remove.addEventListener('click', () => { URL.revokeObjectURL(entry.url); files.splice(index, 1); renderFiles(); });
      const bar = document.createElement('span'); bar.className = 'pr-filebar'; bar.innerHTML = '<span></span>'; entry.bar = bar.firstChild;
      li.append(remove, bar); list.append(li);
    });
  }

  function addFiles(selected) {
    fieldError('media').textContent = '';
    for (const file of selected) {
      const kind = KIND[file.type];
      if (!kind) { fieldError('media').textContent = strings.mediaType; continue; }
      if (kind === 'image' && file.size > LIMITS.imageBytes) { fieldError('media').textContent = strings.mediaImageSize; continue; }
      if (kind === 'video' && file.size > LIMITS.videoBytes) { fieldError('media').textContent = strings.mediaVideoSize; continue; }
      if (files.filter((f) => f.kind === kind).length >= (kind === 'image' ? LIMITS.images : LIMITS.videos)) { fieldError('media').textContent = strings.mediaCount; continue; }
      files.push({ file, kind, url: kind === 'image' ? URL.createObjectURL(file) : '' });
    }
    renderFiles(); picker.value = '';
  }

  function validate() {
    clearErrors();
    const bad = [];
    if (!form.elements.rating.value) bad.push(['rating', strings.rating]);
    if (form.elements.body.value.trim().length < 10) bad.push(['body', strings.body]);
    if (form.elements.name.value.trim().length < 2) bad.push(['name', strings.name]);
    if (!/^[^\s@"'<>]+@[^\s@"'<>]+\.[^\s@"'<>]+$/.test(form.elements.email.value.trim())) bad.push(['email', strings.email]);
    bad.forEach(([name, message]) => showFieldError(name, message));
    if (bad.length) (bad[0][0] === 'rating' ? form.querySelector('.pr-rating input') : form.elements[bad[0][0]]).focus();
    return !bad.length;
  }

  async function post(path, body) {
    const response = await fetch(`${api}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    const data = await response.json().catch(() => ({}));
    return { status: response.status, data };
  }

  function upload(draftId, entry, index, total) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', `${api}/api/reviews/drafts/${draftId}/media`);
      xhr.setRequestHeader('Content-Type', entry.file.type);
      xhr.upload.onprogress = (event) => { if (event.lengthComputable && entry.bar) entry.bar.style.width = `${Math.round((event.loaded / event.total) * 100)}%`; };
      xhr.onload = () => { if (xhr.status === 201) { if (entry.bar) entry.bar.style.width = '100%'; resolve(); } else reject(new Error('upload')); };
      xhr.onerror = () => reject(new Error('upload'));
      statusLine.textContent = fmt(strings.uploading, { c: index + 1, t: total });
      xhr.send(entry.file);
    });
  }

  function failMessage(result) {
    const error = result.data?.error;
    if (result.status === 409 && error === 'already_reviewed') return strings.already;
    if (result.status === 429) return strings.rateLimit;
    return strings.generic;
  }

  async function send(event) {
    event.preventDefault();
    if (busy || !validate()) return;
    busy = true; form.dataset.busy = 'true'; submit.disabled = true; statusLine.textContent = strings.sending;
    try {
      const draft = await post('/api/reviews/drafts', { productId: root.dataset.productId });
      if (draft.status !== 201) throw Object.assign(new Error('draft'), { result: draft });
      files.forEach((entry) => { if (entry.bar) entry.bar.style.width = '0'; });
      try { for (let i = 0; i < files.length; i++) await upload(draft.data.draftId, files[i], i, files.length); }
      catch { formError.textContent = strings.upload; return; }
      statusLine.textContent = strings.sending;
      const result = await post('/api/reviews', {
        draftId: draft.data.draftId, rating: Number(form.elements.rating.value), body: form.elements.body.value.trim(), name: form.elements.name.value.trim(),
        email: form.elements.email.value.trim(), locale: root.dataset.locale || 'nl', website: form.elements.website.value,
      });
      if (result.status !== 201) { formError.textContent = failMessage(result); return; }
      statusLine.textContent = '';
      files.forEach((f) => f.url && URL.revokeObjectURL(f.url)); files = []; renderFiles(); form.reset();
      form.querySelector('[data-review-fields]').hidden = true;
      const success = root.querySelector('[data-review-success]'); success.hidden = false; success.focus();
    } catch (error) { formError.textContent = error.result ? failMessage(error.result) : strings.generic; }
    finally { busy = false; delete form.dataset.busy; submit.disabled = false; if (formError.textContent) statusLine.textContent = ''; } // bij een fout geen "bezig" meer tonen
  }

  openers.forEach((button) => button.addEventListener('click', open));
  root.querySelectorAll('[data-review-close]').forEach((button) => button.addEventListener('click', close));
  dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); }); // klik op de achtergrond sluit het venster
  picker.addEventListener('change', () => addFiles([...picker.files]));
  form.addEventListener('submit', send);
  const more = root.querySelector('[data-review-more]');
  more?.addEventListener('click', () => { root.querySelectorAll('[data-pr-extra]').forEach((el) => { el.hidden = false; }); more.hidden = true; });
  if (location.hash === '#write-review') open(); // voor een link in een e-mail
})();
